<template>

  <Head title="Lihat Dokumen" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <div v-if="hasData">
          <Breadcrumbs :breadcrumbs="breadcrumbs" />
        </div>
        <div v-else class="p-4 mt-4 text-sm text-red-600 rounded bg-red-50">
          Data dokumen tidak ditemukan atau belum tersedia.
        </div>
        <div class="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 class="text-2xl font-bold text-gray-900 sm:text-3xl" v-if="hasData">
              {{ firstRepo.nama_dok }}
            </h1>
            <h1 v-else class="text-xl font-semibold text-gray-500">Tidak ada data</h1>
          </div>
          <div class="flex items-center gap-4">
            <p class="text-sm text-gray-500">
              <span v-if="hasData">Lihat Dokumen Audit Mutu / {{ firstRepo.auditmutu?.standar || 'N/A' }}</span>
              <span v-else>Menunggu data dokumen...</span>
            </p>
          </div>
        </div>
        <div class="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8">
          <div class="h-auto">
            <div class="flow-root py-3 border rounded-lg shadow-xs">
              <dl class="-my-3 text-sm divide-y divide-gray-100">
                <div v-if="hasData" class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt class="font-medium text-gray-900">Nama Dokumen</dt>
                  <dd class="text-gray-700 sm:col-span-2">{{ firstRepo.nama_dok }}</dd>
                </div>

                <div v-if="hasData" class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt class="font-medium text-gray-900">Jenis</dt>
                  <dd class="text-gray-700 sm:col-span-2">{{ firstRepo.jenisdokumen?.nama || '-' }}</dd>
                </div>
                <div v-if="hasData" class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt class="font-medium text-gray-900">Standar</dt>
                  <dd class="text-gray-700 sm:col-span-2">{{ firstRepo.auditmutu?.standar || '-' }}</dd>
                </div>
                <div v-if="hasData" class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt class="font-medium text-gray-900">Deskripsi</dt>
                  <dd class="text-gray-700 sm:col-span-2">{{ firstRepo.deskripsi || '-' }}</dd>
                </div>
                <div v-if="hasData" class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt class="font-medium text-gray-900">Kategori Data</dt>
                  <dd class="text-gray-700 sm:col-span-2">{{ firstRepo.publish }}</dd>
                </div>
                <div v-if="hasData && $page.props.auth.user" class="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dd class="text-gray-700 sm:col-span-2">
                    <div class="flex justify-center space-x-4">
                      <span>
                        <button @click="editDokumen(firstRepo.iddok)"
                          class="flex items-center px-2 py-1 text-xs font-medium text-gray-800 bg-white border border-gray-400 rounded shadow hover:bg-gray-100">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                            class="w-4 h-4 mr-1">
                            <path
                              d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                            <path
                              d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
                          </svg>

                          Edit Dokumen
                        </button>
                      </span>
                      <span>
                        <button @click="editFile(firstRepo.iddok)"
                          class="flex items-center px-2 py-1 text-xs font-medium text-gray-800 bg-white border border-gray-400 rounded shadow hover:bg-gray-100">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                            class="w-4 h-4 mr-1">
                            <path
                              d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                            <path
                              d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
                          </svg>

                          Edit File
                        </button>
                      </span>
                    </div>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
          <div class="h-auto rounded-lg lg:col-span-2">
            <!-- Display multiple files -->
            <div v-if="filePath && filePath.length" class="mt-4">
              <div v-for="(file, index) in filePath" :key="index" class="mb-4">
                <div v-if="isImage(file)" class="inline-block p-2 border rounded-lg" style="
                    width: 300px;
                    height: 300px;
                    margin: 5px;
                    overflow: hidden;
                  ">
                  <img :src="file" alt="Image Preview" class="object-cover w-full h-full" />
                </div>
                <embed v-else-if="isPdf(file)" :src="file" type="application/pdf" class="w-full h-[80vh] mb-2" />
                <p v-else>
                  Preview not available for this file type: {{ file }}
                </p>
              </div>
            </div>
            <ModalEditDokumen v-model:isOpen="isModalOpen" :title="'Edit Dokumen'" :repository="viewdokumen"
              :prodis="selectedProdi" :jenis="selectedJenis" :standar="allStandar" />
            <ModalFile v-model:isOpen="isModalFile" :title="'Edit File'" :repository="viewdokumen" />
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { defineProps, watch, ref, computed } from "vue";
import { Head } from "@inertiajs/vue3";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import ModalEditDokumen from "@/Components/AuditMutu/ModalEditDokumen.vue";
import ModalFile from "@/Components/AuditMutu/ModalFile.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";

const props = defineProps({
  filerepo: {
    type: Array,
    required: true,
  },
  instrumens: {
    type: Object,
    required: true,
  },
});
const isModalOpen = ref(false);
const isModalFile = ref(false);
const viewdokumen = ref(null);
const selectedJenis = ref(null);
const selectedProdi = ref(null);
const allStandar = ref([]);

const hasData = computed(() => props.filerepo && props.filerepo.data && props.filerepo.data.length > 0);
const firstRepo = computed(() => (hasData.value ? props.filerepo.data[0] : {}));
const filePath = ref(hasData.value ? firstRepo.value.file_path : []);
const breadcrumbs = computed(() => {
  if (!hasData.value) return [];
  return [
    { name: 'Dashboard', href: route('dashboard') },
    { name: 'Audit Mutu Program Studi', href: route('auditmutu.index') },
    {
      name: firstRepo.value.auditmutu?.standar || 'Standar',
      href: route('auditmutu.adddocument', firstRepo.value.auditmutu?.slug || ''),
    },
    {
      name: firstRepo.value.nama_dok,
      href: route('auditmutu.show', firstRepo.value.iddok),
    },
  ];
});

watch(
  () => props.filerepo,
  (newFilerepo) => {
    if (newFilerepo && newFilerepo.data && newFilerepo.data.length) {
      filePath.value = newFilerepo.data[0].file_path;
    } else {
      filePath.value = [];
    }
  }
);

const editDokumen = async (iddok) => {
  try {
    const response = await fetch(route('auditmutu.showdoc', iddok));
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    selectedProdi.value = data.prodis;
    allStandar.value = data.standar; // simpan semua standar
    isModalOpen.value = true;
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};
const editFile = async (iddok) => {
  try {
    const response = await fetch(route('auditmutu.showdoc', iddok));
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    allStandar.value = data.standar;
    isModalFile.value = true;
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};
// Check if file is an image
function isImage(filePath) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
}

// Check if file is a PDF
function isPdf(filePath) {
  return /\.pdf$/i.test(filePath);
}
</script>
